var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hasInflections
    ? _c(
        "div",
        { class: _vm.listClasses },
        _vm._l(_vm.inflections, function (inflset, ifindex) {
          return _c(
            "div",
            { key: ifindex, staticClass: "alpheios-morph__inflset" },
            [
              _vm.inflections.length > 1
                ? _c(
                    "span",
                    { staticClass: "alpheios-inflections-list__inflset_index" },
                    [_vm._v(_vm._s(ifindex + 1) + ".")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "alpheios-inflections-list__forms" },
                [
                  _vm._l(
                    _vm.featuresList.wordParts.filter(function (feat) {
                      return inflset.groupingKey[feat.name]
                    }),
                    function (feat) {
                      return _c(
                        "span",
                        {
                          key: feat.name,
                          staticClass: "alpheios-inflections-list__formtext",
                          attrs: {
                            lang: _vm.languageCode,
                            "data-grouplevel": "1",
                            "data-feature": "feat.name",
                          },
                        },
                        [
                          _vm._v(
                            _vm._s(
                              feat.template.replace(
                                "%s",
                                inflset.groupingKey[feat.name]
                              )
                            )
                          ),
                        ]
                      )
                    }
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    { staticClass: "alpheios-inflections-list__inflfeatures" },
                    _vm._l(
                      _vm.featuresList.level1.filter(function (feat) {
                        return feat.checkfn(inflset)
                      }),
                      function (feat) {
                        return _c("inflectionattribute", {
                          key: feat.name,
                          attrs: {
                            data: inflset.groupingKey,
                            grouplevel: 1,
                            decorators: feat.decorators,
                            type: _vm.types[feat.name],
                          },
                        })
                      }
                    ),
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(inflset.inflections, function (group, grInflIndex) {
                    return _c(
                      "div",
                      {
                        key: grInflIndex,
                        staticClass: "alpheios-inflections-list__inflgroup",
                      },
                      [
                        group.groupingKey.isCaseInflectionSet
                          ? _c(
                              "span",
                              _vm._l(_vm.featuresList.level2, function (feat) {
                                return _c("inflectionattribute", {
                                  key: feat.name,
                                  attrs: {
                                    data: group.groupingKey,
                                    grouplevel: 2,
                                    decorators: feat.decorators,
                                    type: _vm.types[feat.name],
                                  },
                                })
                              }),
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(
                          group.inflections,
                          function (nextGroup, nextGrInflIndex) {
                            return _c(
                              "div",
                              {
                                key: nextGrInflIndex,
                                class: _vm.groupClass(group),
                              },
                              [
                                group.groupingKey.isCaseInflectionSet
                                  ? _c(
                                      "span",
                                      _vm._l(
                                        _vm.featuresList.level3,
                                        function (feat) {
                                          return _c("inflectionattribute", {
                                            key: feat.name,
                                            attrs: {
                                              data: group.groupingKey,
                                              grouplevel: 3,
                                              decorators: feat.decorators,
                                              type: _vm.types[feat.name],
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm._l(
                                  nextGroup.inflections,
                                  function (infl, nextGrInflIndex2) {
                                    return _c(
                                      "div",
                                      {
                                        key: nextGrInflIndex2,
                                        class: _vm.groupClass(group),
                                      },
                                      [
                                        _vm._l(
                                          _vm.featuresList.level4.filter(
                                            function (feat) {
                                              return feat.checkfn(infl, group)
                                            }
                                          ),
                                          function (feat) {
                                            return _c("inflectionattribute", {
                                              key: feat.name,
                                              attrs: {
                                                data: infl.groupingKey,
                                                grouplevel: 4,
                                                decorators: feat.decorators,
                                                type: _vm.types[feat.name],
                                              },
                                            })
                                          }
                                        ),
                                        _vm._v(" "),
                                        _vm._l(
                                          infl.inflections,
                                          function (item, indexItem) {
                                            return _c(
                                              "span",
                                              { key: indexItem },
                                              [
                                                _c("inflectionattribute", {
                                                  attrs: {
                                                    data: item,
                                                    decorators: [
                                                      "parenthesize",
                                                    ],
                                                    type: "dialect",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c("inflectionattribute", {
                                                  attrs: {
                                                    data: item,
                                                    type: "example",
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    )
                                  }
                                ),
                              ],
                              2
                            )
                          }
                        ),
                        _vm._v(" "),
                        _c(
                          "tooltip",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.disambiguated,
                                expression: "disambiguated",
                              },
                            ],
                            staticClass:
                              "alpheios-inflections-list__pointer-tooltip",
                            attrs: {
                              "tooltip-text": _vm.l10n.getText(
                                "TOOLTIP_DISAMBIGUATED"
                              ),
                              "tooltip-direction": "top",
                            },
                          },
                          [
                            _c("disambiguated-icon", {
                              staticClass:
                                "alpheios-inflections-list__pointer-icn alpheios-disambiguated-icon",
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.disambiguated,
                                expression: "disambiguated",
                              },
                            ],
                            staticClass:
                              "alpheios-inflections-list_dsmbg-providers",
                          },
                          [
                            _c(
                              "tooltip",
                              {
                                staticClass:
                                  "alpheios-inflections-list__dsmbg-providers-tooltip",
                                attrs: {
                                  "tooltip-text": _vm.l10n.getText(
                                    "TOOLTIP_TREEBANK_SOURCE"
                                  ),
                                  "tooltip-direction": "top",
                                },
                              },
                              [
                                _c("treebank-icon", {
                                  staticClass:
                                    "alpheios-inflections-list__dsmbg-providers-icn alpheios-treebank-icon",
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      2
                    )
                  }),
                ],
                2
              ),
            ]
          )
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }